var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongXunhuan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9 3.337a5.502 5.502 0 013.49 6.262 1.798 1.798 0 00-1.013-.049A4.508 4.508 0 009.6 4.293c.183-.275.291-.603.298-.956zM8 14c1.381 0 2.643-.509 3.61-1.35a1.8 1.8 0 01-.542-.858A4.485 4.485 0 018 13a4.48 4.48 0 01-2.618-.84c-.165.302-.413.551-.713.717A5.476 5.476 0 008 14zM2.678 9.893A5.509 5.509 0 016.3 3.268V3.3c0 .342.095.662.261.935A4.502 4.502 0 003.614 9.51a1.791 1.791 0 00-.936.383z",
    fill: "#3F465C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.1,
    cy: 3.3,
    r: 1.8,
    stroke: "#3F465C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8,
    cy: 11.3,
    r: 1.8,
    stroke: "#3F465C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.8,
    cy: 11.3,
    r: 1.8,
    stroke: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_xunhuan.8f12ac66.svg";
export { SvgTongyongXunhuan as ReactComponent };